jQuery(document).ready(function ($) {
    'use strict'

    // Invoke mobile menu
    if ($('.menuTrigger').length) {
        $.mtcMobileMenu({
            move_site: true,
            position: 'left',
            is_fixed: false
        })
    }

    // Remove HTML5 validation
    if ($('form').length) {
        $('form').attr('novalidate', 'novalidate')
    }

    // Animate all top links
    $('a[href="#top"]').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 'slow')
        return false;
    })
}) // document ready
